module.exports = __webpack_public_path__ + "img/voice_quh.a031fcb9.png";